module.exports = __webpack_public_path__ + "img/5.2e556aa8.jpg";